import template from './client.html';
import controller from './client.controller';
import './client.scss';

let clientComponent = {
  bindings: {},
  template,
  controller
};

export default clientComponent;



// WEBPACK FOOTER //
// ./client/app/components/client/client.component.js